<template>
<!-- viewBox="0 0 997 434" -->
  <svg xmlns="http://www.w3.org/2000/svg">
    <path class="cls-1" fill="#1a1e1c" d="M84.12 379h602.2v4.06H84.12z"/>
    <ellipse class="cls-2" cx="123.2" cy="373.1" rx="96.5" ry="25.87" fill="#3f1812"/>
    <ellipse class="cls-3" cx="123.2" cy="367.4" rx="96.5" ry="25.87" fill="#4f2117"/>
    <path d="M33.25 101v261c0 12.15 40.29 22 90 22s90-9.85 90-22V101z" fill="#5e2d1e"/>
    <path d="M200.7 366.8v-2.516H43.4v1.195c12.14 7.903 43.25 13.54 79.82 13.54 34.48 0 64-5.023 77.46-12.22z" fill="#232323"/>
    <!-- <path id="itemPetrol1" d="M37.92 244v114.1c0 2.581 2.007 5.041 5.512 7.322v-1.195h157.3v2.516c4.94-2.64 7.867-5.55 7.867-8.643V244h-170.7z" fill="#232323"/> -->
    <rect id="itemPetrol1" x="37.92" :y="366 - h*progress" width="170" :height="h*progress" fill="#232323"/>
    <ellipse id="itemPetrol2" cx="123.2" :cy="366.6 - h*progress" rx="85.5" ry="15.87" fill="#383838"/>
    <path class="cls-7" d="M203 101v271.2c6.51-3 10.2-6.5 10.2-10.17v-261z" fill="#77382a"/>
    <path class="cls-8" fill="#994c3f" d="M200 109h3v263h-3z"/>
    <path class="cls-7" d="M41.45 101h-8.2v261c0 3.28 2.94 6.39 8.2 9.18z" fill="#77382a"/>
    <path class="cls-8" fill="#994c3f" d="M41 109h3v263h-3z"/>
    <ellipse class="cls-2" cx="123.2" cy="97.5" rx="96.5" ry="26.5" fill="#3f1812"/>
    <ellipse class="cls-3" cx="123.2" cy="93" rx="96.5" ry="26.5" fill="#4f2117"/>
    <ellipse class="cls-7" cx="123.2" cy="93" rx="84" ry="20.5" fill="#77382a"/>
    <ellipse class="cls-2" cx="172.4" cy="91.39" rx="16.78" ry="4.61" fill="#3f1812"/>
    <ellipse class="cls-3" cx="172.4" cy="90.61" rx="16.78" ry="4.61" fill="#4f2117"/>
    <path class="cls-2" d="M216 271.5c-3.25 11.71-43.55 21-92.78 21s-89.53-9.26-92.78-21c-2.42 2.33-3.72 4.8-3.72 7.35 0 14.7 43.2 26.62 96.5 26.62s96.5-11.92 96.5-26.62c.03-2.55-1.27-5.02-3.72-7.35z" fill="#3f1812"/>
    <path class="cls-3" d="M213.2 263.4v3.13c0 12.15-40.3 22-90 22s-90-9.85-90-22v-3c-4.15 3-6.43 6.17-6.43 9.53 0 14.64 43.2 26.5 96.5 26.5s96.5-11.86 96.5-26.5c0-3.43-2.33-6.67-6.57-9.66z" fill="#4f2117"/>
    <path class="cls-2" d="M216 173.5c-3.25 11.71-43.55 21-92.78 21s-89.53-9.26-92.78-21c-2.42 2.33-3.72 4.8-3.72 7.35 0 14.7 43.2 26.62 96.5 26.62s96.5-11.92 96.5-26.62c.03-2.55-1.27-5.02-3.72-7.35z" fill="#3f1812"/>
    <path class="cls-3" d="M213.2 165.4v3.13c0 12.15-40.3 22-90 22s-90-9.85-90-22v-3c-4.15 3-6.43 6.17-6.43 9.53 0 14.64 43.2 26.5 96.5 26.5s96.5-11.86 96.5-26.5c0-3.43-2.33-6.67-6.57-9.66z" fill="#4f2117"/>
    <g id="itemPetrol6">
      <path class="cls-1" fill="#1a1e1c" d="M668.5 208.2h1.35v173.6h-1.35z"/>
      <path class="cls-9" fill="#3c4744" d="M666.1 289.8h6.09v2.71h-6.09zM666.1 283.9h6.09v2.71h-6.09z"/>
    </g>
    <circle class="cls-10" cx="669.1" cy="355.4" r="4.06" fill="#83b0ba"/>
    <path class="cls-9" fill="#3c4744" d="M667.1 362.1h4.06v44.66h-4.06z"/>
    <path class="cls-1" fill="#1a1e1c" d="M663.7 360.1h10.83v2.71H663.7zM659.3 402.1h19.62v7.44H659.3z"/>
    <circle class="cls-10" cx="669.1" cy="380.7" r="7.1" fill="#83b0ba"/>
    <ellipse class="cls-10" cx="687" cy="381.1" rx="2.71" ry="4.74" fill="#83b0ba"/>
    <path fill="#25352d" d="M814.2 299.9h102.1l25.7 89.3H814.2z"/>
    <g id="itemPetrol5">
      <path d="M710.1 168.4l-4-1.33 10.59-25.15 10.59 5.3-1.31-58.24c-78.1 60.89-59.56 145.6-59.56 145.6l54.26-64.86-9.26-4zm-11.92-39.71l14.56-17.21 9.27 4v15.89l-14.56 4-9.27-4zm-21.21 86.29l-5.26-1.58a95.09 95.09 0 0 1 5.26-47.65l6.62-2.65 9.27 4 6.65 19.88zm19.89-53.2l-11.89-5.3-2.65-4 6.65-13.2 5.29-2.65 10.59 4z" fill="#7fd0dd"/>
      <path d="M666.4 235.6a1 1 0 0 1-.24 0 1 1 0 0 1-.74-.76c-.05-.21-4.62-21.7.49-50.35 4.71-26.44 18.84-64.6 59.43-96.25a1 1 0 0 1 1.05-.11 1 1 0 0 1 .56.87l1.32 58.24a1 1 0 0 1-.46.86 1 1 0 0 1-1 0l-9.63-4.81-9.75 23.17 2.12.7.93-1.87a1 1 0 0 1 1.29-.47l9.27 4a1 1 0 0 1 .58.69 1 1 0 0 1-.21.87l-54.27 64.86a1 1 0 0 1-.74.36zM725 91c-38.85 31-52.51 68-57.11 93.69a146.5 146.5 0 0 0-.89 47.6l52-62.19-7.16-3.07-.9 1.8a1 1 0 0 1-1.21.51l-4-1.33a1 1 0 0 1-.6-.53 1.06 1.06 0 0 1 0-.8l10.59-25.15a1 1 0 0 1 1.37-.51l9.1 4.55zm-48.05 125a1 1 0 0 1-.29 0l-5.26-1.58a1 1 0 0 1-.7-.81 96.87 96.87 0 0 1 5.37-48.2 1 1 0 0 1 .54-.53l6.62-2.65a1.08 1.08 0 0 1 .77 0l9.26 4a1.05 1.05 0 0 1 .56.61l6.61 19.85a1 1 0 0 1-.16.94l-22.54 28.06a1 1 0 0 1-.78.31zm-4.36-3.35l4 1.2 21.78-27.1-6.31-18.91-8.47-3.63-5.84 2.33a95.44 95.44 0 0 0-5.16 46.11zm24.25-49.85a1 1 0 0 1-.41-.09l-11.91-5.29a1.07 1.07 0 0 1-.43-.36l-2.64-4a1 1 0 0 1-.07-1l6.62-13.24a1.08 1.08 0 0 1 .45-.45l5.29-2.64a1 1 0 0 1 .8 0l10.59 4a1 1 0 0 1 .59 1.29l-7.94 21.18a1 1 0 0 1-.55.57 1.09 1.09 0 0 1-.39.03zm-11.24-7.09l10.68 4.74 7.21-19.24-9.24-3.47-4.61 2.3-6.21 12.42zm21.83-19.38a1.1 1.1 0 0 1-.4-.08l-9.26-4a1 1 0 0 1-.61-.91v-2.65a1 1 0 0 1 .24-.65l14.55-17.18a1 1 0 0 1 1.16-.28l9.26 4a1 1 0 0 1 .61.92v15.89a1 1 0 0 1-.74 1l-14.56 4a1.17 1.17 0 0 1-.25-.06zm-8.27-5.63l8.34 3.57 13.45-3.68v-14.46l-8-3.42-13.85 16.36z" fill="#59797c"/>
      <path fill="#3c5c68" stroke="#74a6b5" stroke-miterlimit="10" stroke-width="3" d="M718.6 146.6l199.2 75.2.1 19.4L712 163.9z"/>
    </g>
    <path d="M846 344.5h-60.92a2 2 0 1 1 0-4H838l-51.16-27.36a2 2 0 0 1-1-2.19l2-9.47a2 2 0 0 1 1-1.31l43.38-25-2.21-10-32.51-21.83a2 2 0 0 1-.87-1.91l.67-5.41a2 2 0 0 1 2-1.75H827a2 2 0 0 1 0 4h-26l-.3 2.44 32.13 21.64a2 2 0 0 1 .84 1.23l2.7 12.18a2 2 0 0 1-.95 2.16l-43.88 25.27-1.53 7.13 56.86 30.41a2 2 0 0 1-.95 3.77z" fill="#67969b"/>
    <path class="cls-16" d="M831.1 274.2h-36.54a2 2 0 0 1 0-4h36.54a2 2 0 0 1 0 4zM837.9 308h-48a2 2 0 0 1 0-4h48a2 2 0 1 1 0 4z" fill="#4c7d7f"/>
    <path class="cls-10" fill="#83b0ba" d="M854.4 364.3h-6.6L820 218.7h-15.9l-21.2 145.6h-9.2l6.6-17.2 21.2-139H824z"/>
    <g fill="#1a1e1c">
      <path class="cls-1" d="M769.5 373.6h10.83v35.86H769.5zM837.9 373.6h10.83v35.86H837.9zM900.1 373.6h20.3v35.86h-20.3z"/>
    </g>
    <path class="cls-9" fill="#3c4744" d="M925.8 293.8l17.6 12.2 24.4 4v26.4h-97.5l2.1-29.7z"/>
    <circle class="cls-17" cx="812.4" cy="204.2" r="6.62" fill="#48787a"/>
    <circle class="cls-17" cx="812.9" cy="204.2" r="6.62" fill="#48787a"/>
    <circle class="cls-10" cx="812.9" cy="204.2" r="3.63" fill="#83b0ba"/>
    <path class="cls-9" fill="#3c4744" d="M766.1 362.8h92.36v13.53H766.1z"/>
    <path class="cls-1" fill="#1a1e1c" d="M948.8 309.4h23.68v100.1H948.8z"/>
    <g id="itemPetrol3">
      <path class="cls-18" d="M876.4 359.4s18.27-11.5 60.22-5.41c0 0 12.86-1.35 6.77 10.15 0 0-10.83 14.21-35.86 16.91 0 0-26.39 2.71-37.89-10.15 0 0-7.45-10.15 6.76-11.5z" fill="#627770"/>
      <path class="cls-19" d="M911.8 314.3a10.49 10.49 0 1 0-20.9 1.81v.33l5.89 68.09 20.89-1.81-5.89-68.09c.01-.11.02-.22.01-.33z" fill="#8c9995"/>
      <circle cx="904" cy="352.8" r="7.78" fill="#45544f"/>
      <circle cx="904" cy="352.8" r="2.71" fill="#202825"/>
    </g>
    <g id="itemPetrol4">
      <path class="cls-1" fill="#1a1e1c" d="M903 253.2h2.03v98.78H903z"/>
      <path class="cls-18" fill="#627770" d="M900.3 228.2h7.44v17.59h-7.44z"/>
      <path class="cls-19" fill="#8c9995" d="M897.6 243.7h12.9l-2.1 14.9h-8.8z"/>
    </g>
  </svg>

</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 50,
    }
  },
  data(){
    return {
      h: 270,
    }
  }
}
</script>
<style scoped>
  #itemPetrol1, #itemPetrol2 {
    transition: all 500ms;
  }
  @keyframes anim1 {
    from{ transform: rotate(0)}
    to{ transform: rotate(359deg)}
  }
  #itemPetrol3 {
    transform-origin: 904px 315px;
    /* transform: rotate(270deg); */
    animation: anim1;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes anim2 {
    /* Se podrían calcular los angulos y posiciones matemáticamente pero esta aproximación no esta tan mal */
    0%{ transform: translate(0, 0)}
    12%{ transform: rotate(15deg) translate(-23px, -12px)}
    25%{ transform: rotate(20deg) translate(-40px, -25px)}
    37%{ transform: rotate(15deg) translate(-35px, -50px)}
    50%{ transform: rotate(0) translate(0, -75px)}
    62%{ transform: rotate(-15deg) translate(35px, -50px)}
    75%{ transform: rotate(-20deg) translate(40px, -25px)}
  }
  #itemPetrol4 {
    transform-origin: 904px 315px;
    animation: anim2;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes anim3 {
    0%{ transform: rotate(0)}
    50%{ transform: rotate(-40deg)}
  }
  #itemPetrol5 {
    transform-origin: 812px 200px;
    animation: anim3;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes anim4 {
    0%{ transform: translateY(-30px)}
    50%{ transform: translateY(10px)}
    100%{ transform: translateY(-30px)}
  }
  #itemPetrol6 {
    animation: anim4;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .cls-1{fill:#1a1e1c}.cls-2{fill:#3f1812}.cls-3{fill:#4f2117}.cls-7{fill:#77382a}.cls-8{fill:#994c3f}.cls-9{fill:#3c4744}.cls-10{fill:#83b0ba}.cls-16{fill:#4c7d7f}.cls-17{fill:#48787a}.cls-18{fill:#627770}.cls-19{fill:#8c9995}
</style>